import {
  SUPERADMIN_ALL_USER_LIST,
  SUPERADMIN_USER_ALL_DETAILS,
  EDITUSER_DATA_STEP1_HOME,
  EDITUSER_DATA_STEP2_HOME,
  EDITUSER_DATA_STEP3_HOME,
  EDITUSER_DATA_STEP4_HOME,
  EDITUSER_DATA_STEP1,
  EDITUSER_DATA_STEP2,
  EDITUSER_DATA_STEP3,
  EDITUSER_DATA_STEP4,
  SUPERADMIN_USER_ISSUES_LIST,
  SUPERADMIN_ADD_COMMENT_ISSUE,
  SUPERADMIN_UPDATE_TICKET_STATUS,
  SUPERADMIN_USER_ISSUE_DETAIL,
  SUPERADMIN_CHANGE_STATUS_ISSUE_DETAIL,
  SUPERADMIN_USER_DELETE,
  SUPERADMIN_USER_BLOCK,
  SUPERADMIN_USER_BLOCK_HOME,
  SUPERADMIN_USER_FLAG_HOME,
  SUPERADMIN_USER_FLAG,
  USER_RESTAURANT_ACTIVITY,
  USER_OFFER_ACTIVITY,
  USER_EVENT_ACTIVITY,
  USER_STREAMING_ACTIVITY,
  USER_ITEM_ACTIVITY,
  USER_TRACK_VIDEO,
  USER_RESTAURANT_FAVOURITES,
  USER_CLOSE_WALLET_REQUESTS,
  USER_OFFER_FAVOURITES,
  USER_EVENT_FAVOURITES,
  GET_GROUP_BY_FAVOURITES,
  SUPERADMIN_USER_DETAILS_DATE_RANGE,
  SA_USER_DETAILS_SEATING,
  SA_USER_DETAILS_OFFERS,
  SA_USER_DETAILS_EXPERIENCE,
  SA_USER_DETAILS_VIDEO_CONTENT,
  SA_USER_DETAILS_LIVE_STREAMING,
  SA_USER_DETAILS_USER_TICKETS,
  SA_USER_DETAILS_MISCELLANEOUS,
  SA_USER_DETAILS_REFERRAL,
  SA_USER_DETAILS_REVIEWS,
  SA_USER_DETAILS_FAVOURITES,
  SA_USER_DETAILS_NOMINATIONS,
  SA_USER_DETAILS_WALLET,
  SA_USER_DETAILS_EVENTS,
  SA_USER_DETAILS_ORDERING,
  SUPERADMIN_USER_ARCHIVE,
  SUPERADMIN_USER_ARCHIVE_HOME,
  SUPERADMIN_ALL_USER_STATS,
  SUPERADMIN_ALL_USER_RANGE,
  SA_USER_DETAILS_REELS,
} from "../../types";

const initialState = {
  allUserRange: '',
  allUserStats: {},
  allUserList: [],
  userAllData: [],
  allUserIssues: [],
  issueDetail: [],
  userRestaurantActivity: [],
  userOfferActivity: [],
  userEventActivity: [],
  userStreamingActivity: [],
  userItemActivity: [],
  userTrackVideo: [],
  userRestaurantFavourites: [],
  userOfferFavourites: [],
  userEventFavourites: [],
  groupByFavourites: [],
  tempAddRemoveLoader: false,
  dateRange: {},
  userReels:{},
  userSeating: {},
  userOrdering: {},
  userEvents: {},
  userWallet: {},
  userNominations: {},
  userFavourites: {},
  userReviews: {},
  userReferral: {},
  userMiscellaneous: {},
  userTickets: {},
  userLiveStreaming: {},
  userVideoContent: {},
  userOffers: {},
  Userexperiences:{},
  closeWalletRequests: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SUPERADMIN_ALL_USER_LIST:
      return {
        ...state,
        allUserList: action.payload,
      };
    case SUPERADMIN_ALL_USER_STATS:
      return {
        ...state,
        allUserStats: action.payload,
      };
    case SUPERADMIN_ALL_USER_RANGE:
      return {
        ...state,
        allUserRange: action.payload,
      };
    case SUPERADMIN_USER_ALL_DETAILS:
      return {
        ...state,
        userAllData: action.payload,
      };

    case SUPERADMIN_USER_DETAILS_DATE_RANGE:
      return {
        ...state,
        dateRange: action.payload,
      };

    case SA_USER_DETAILS_SEATING:
      return {
        ...state,
        userSeating: action.payload,
      };
    case SA_USER_DETAILS_REELS:
      return {
        ...state,
        userReels: action.payload,
      };
    
    case SA_USER_DETAILS_ORDERING:
      return {
        ...state,
        userOrdering: action.payload,
      };
    case SA_USER_DETAILS_EVENTS:
      return {
        ...state,
        userEvents: action.payload,
      };
    case SA_USER_DETAILS_WALLET:
      return {
        ...state,
        userWallet: action.payload,
      };
    case SA_USER_DETAILS_NOMINATIONS:
      return {
        ...state,
        userNominations: action.payload,
      };
    case SA_USER_DETAILS_FAVOURITES:
      return {
        ...state,
        userFavourites: action.payload,
      };
    case SA_USER_DETAILS_REVIEWS:
      return {
        ...state,
        userReviews: action.payload,
      };
    case SA_USER_DETAILS_REFERRAL:
      return {
        ...state,
        userReferral: action.payload,
      };
    case SA_USER_DETAILS_MISCELLANEOUS:
      return {
        ...state,
        userMiscellaneous: action.payload,
      };
    case SA_USER_DETAILS_USER_TICKETS:
      return {
        ...state,
        userTickets: action.payload,
      };
    case SA_USER_DETAILS_LIVE_STREAMING:
      return {
        ...state,
        userLiveStreaming: action.payload,
      };
    case SA_USER_DETAILS_VIDEO_CONTENT:
      return {
        ...state,
        userVideoContent: action.payload,
      };
    case SA_USER_DETAILS_OFFERS:
      return {
        ...state,
        userOffers: action.payload,
      };
    case SA_USER_DETAILS_EXPERIENCE:
      return {
        ...state,
        Userexperiences: action.payload,
      };

    case EDITUSER_DATA_STEP1_HOME:
      let updateStep1Home = state.allUserList.map((item) => {
        if (item._id === action.payload._id) {
          return {
            ...item,
            email: action.payload.email,
            mobile_number: action.payload.mobile_number,
            birthday_day: action.payload.birthday_day,
            birthday_month: action.payload.birthday_month,
            anniversary_day: action.payload.anniversary_day,
            anniversary_month: action.payload.anniversary_month,
            address: action.payload.address,
            country_id: action.payload.country_id,
            country: action.payload.country,
            state_id: action.payload.state_id,
            state: action.payload.state,
            city: action.payload.city,
            city_id: action.payload.city_id,
            updatedAt: action.payload.updatedAt,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        allUserList: updateStep1Home,
      };

    case EDITUSER_DATA_STEP1:
      let updateStep1Data = state.userAllData;
      updateStep1Data.email = action.payload.email;
      updateStep1Data.mobile_number = action.payload.mobile_number;
      updateStep1Data.birthday_day = action.payload.birthday_day;
      updateStep1Data.birthday_month = action.payload.birthday_month;
      updateStep1Data.anniversary_day = action.payload.anniversary_day;
      updateStep1Data.anniversary_month = action.payload.anniversary_month;
      updateStep1Data.address = action.payload.address;
      updateStep1Data.country_id = action.payload.country_id;
      updateStep1Data.country = action.payload.country;
      updateStep1Data.city = action.payload.city;
      updateStep1Data.city_id = action.payload.city_id;
      updateStep1Data.state_id = action.payload.state_id;
      updateStep1Data.state = action.payload.state;
      return {
        ...state,
        userAllData: updateStep1Data,
      };

    case EDITUSER_DATA_STEP2_HOME:
      let updateStep2Home = state.allUserList.map((item) => {
        if (item._id === action.payload._id) {
          let oc = action.payload;
          let dateUpdated = action.payload.updatedAt;
          delete oc["_id"];
          delete oc["updatedAt"];
          return {
            ...item,
            occasion: oc,
            updatedAt: dateUpdated,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        allUserList: updateStep2Home,
      };

    case EDITUSER_DATA_STEP2:
      let updateStep2Data = state.userAllData;
      updateStep2Data.occasion = action.payload;
      //updateStep2Data.occasion = action.payload;

      return {
        ...state,
        userAllData: updateStep2Data,
      };

    case EDITUSER_DATA_STEP3_HOME:
      let updateStep3Home = state.allUserList.map((item) => {
        if (item._id === action.payload._id) {
          return {
            ...item,
            day_you_eat_out: action.payload.day_you_eat_out,
            selected_cuisine: action.payload.selected_cuisine,
            favourite_places: action.payload.favourite_places,
            birthday_month: action.payload.birthday_month,
            allergies_flag: action.payload.allergies_flag,
            do_you_have_allergies: action.payload.do_you_have_allergies,
            dietary_preferences: action.payload.dietary_preferences,
            dietary_preferences_flag: action.payload.dietary_preferences_flag,
            updatedAt: action.payload.updatedAt,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        allUserList: updateStep3Home,
      };

    case EDITUSER_DATA_STEP3:
      let updateStep3Data = state.userAllData;
      updateStep3Data.day_you_eat_out = action.payload.day_you_eat_out;
      updateStep3Data.selected_cuisine = action.payload.selected_cuisine;
      updateStep3Data.favourite_places = action.payload.favourite_places;

      updateStep3Data.allergies_flag = action.payload.allergies_flag;
      updateStep3Data.do_you_have_allergies =
        action.payload.do_you_have_allergies;
      updateStep3Data.dietary_preferences = action.payload.dietary_preferences;
      updateStep3Data.dietary_preferences_flag =
        action.payload.dietary_preferences_flag;

      return {
        ...state,
        userAllData: updateStep3Data,
      };

    case EDITUSER_DATA_STEP4_HOME:
      var updateStep4Home = state.allUserList.map((item) => {
        if (item._id === action.payload._id) {
          return {
            ...item,
            selected_chain: action.payload.selected_chain,
            updatedAt: action.payload.updatedAt,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        allUserList: updateStep4Home,
      };

    case EDITUSER_DATA_STEP4:
      let updateStep4Data = state.userAllData;
      updateStep4Data.selected_chain = action.payload.selected_chain;

      return {
        ...state,
        userAllData: updateStep4Data,
      };

    case SUPERADMIN_UPDATE_TICKET_STATUS:
      var updateTicketStatus = state.allUserIssues.map((ticket) => {
        if (ticket._id === action.payload.id) {
          return {
            ...ticket,
            status: action.payload.status,
          };
        } else {
          return ticket;
        }
      });
      return {
        ...state,
        allUserIssues: updateTicketStatus,
      };
    case SUPERADMIN_USER_ISSUES_LIST:
      return {
        ...state,
        allUserIssues: action.payload,
      };

    case SUPERADMIN_ADD_COMMENT_ISSUE:
      var updateComment = state.issueDetail;
      updateComment.comment = action.payload.comment;
      return {
        ...state,
        issueDetail: updateComment,
      };

    case SUPERADMIN_USER_ISSUE_DETAIL:
      return {
        ...state,
        issueDetail: action.payload,
      };

    case SUPERADMIN_CHANGE_STATUS_ISSUE_DETAIL:
      state.issueDetail.status = action.payload.status;
      return {
        ...state,
        issueDetail: state.issueDetail,
      };
    case SUPERADMIN_USER_DELETE:
      return {
        ...state,
        userAllData: [],
      };
    case SUPERADMIN_USER_BLOCK:
      let blockUserDetailPage = state.userAllData;
      blockUserDetailPage.user_blocked = action.payload;

      return {
        ...state,
        userAllData: blockUserDetailPage,
      };

    case SUPERADMIN_USER_BLOCK_HOME:
      let blockUserHomePage = state.allUserList.map((item) => {
        if (item._id === action.payload.userId) {
          return {
            ...item,
            user_blocked: action.payload.user_blocked,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        allUserList: blockUserHomePage,
      };

    case SUPERADMIN_USER_FLAG:
      let flagUserDetailPage = state.userAllData;
      flagUserDetailPage.isFlag = action.payload;

      return {
        ...state,
        issueDetail: flagUserDetailPage,
      };

    case SUPERADMIN_USER_FLAG_HOME:
      let flagUserHomePage = state.allUserList.map((item) => {
        if (item._id === action.payload.userId) {
          return {
            ...item,
            isFlag: action.payload.isFlag,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        allUserList: flagUserHomePage,
      };
    case SUPERADMIN_USER_ARCHIVE:
      let archiveUserDetailPage = state.userAllData;
      archiveUserDetailPage.isArchive = action.payload;

      return {
        ...state,
        issueDetail: archiveUserDetailPage,
      };

    case SUPERADMIN_USER_ARCHIVE_HOME:
      let archiveUserHomePage = state.allUserList.map((item) => {
        if (item._id === action.payload.userId) {
          return {
            ...item,
            isArchive: action.payload.isArchive,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        allUserList: archiveUserHomePage,
      };

    case USER_RESTAURANT_ACTIVITY:
      return {
        ...state,
        userRestaurantActivity: action.payload.data,
      };
    case USER_OFFER_ACTIVITY:
      return {
        ...state,
        userOfferActivity: action.payload.data,
      };
    case USER_EVENT_ACTIVITY:
      return {
        ...state,
        userEventActivity: action.payload.data,
      };
    case USER_STREAMING_ACTIVITY:
      return {
        ...state,
        userStreamingActivity: action.payload.data,
      };
    case USER_ITEM_ACTIVITY:
      return {
        ...state,
        userItemActivity: action.payload.data,
      };
    case USER_TRACK_VIDEO:
      return {
        ...state,
        userTrackVideo: action.payload.data,
      };
    case USER_RESTAURANT_FAVOURITES:
      return {
        ...state,
        userRestaurantFavourites: action.payload.data,
      };
    case USER_CLOSE_WALLET_REQUESTS:
      return {
        ...state,
        closeWalletRequests: action.payload.data,
      };
    case USER_OFFER_FAVOURITES:
      return {
        ...state,
        userOfferFavourites: action.payload.data,
      };
    case USER_EVENT_FAVOURITES:
      return {
        ...state,
        userEventFavourites: action.payload.data,
      };
    case "TEMP_ADD_LOADER":
      return {
        ...state,
        tempAddRemoveLoader: true,
      };
    case "TEMP_REMOVE_LOADER":
      return {
        ...state,
        tempAddRemoveLoader: false,
      };

    case GET_GROUP_BY_FAVOURITES:
      return {
        ...state,
        groupByFavourites: action.payload,
      };
    default:
      return state;
  }
}
